import { useAppDispatch, useAppSelector } from '@hooks/app/redux';
import { actions } from '@store/ducks/auth';
import React from 'react';
import { STEPS } from '../../registration.types';

const RegDevTools: React.FunctionComponent = () => {
  const step = useAppSelector((state) => state.auth.currentRegStep);
  const dispatch = useAppDispatch();

  const goForth = () => {
    if (step + 1 >= Object.keys(STEPS).length) {
      return;
    }

    dispatch(actions.setCurrentRegStep(step + 1));
  };

  const goBack = () => {
    if (step - 1 < 0) {
      return;
    }

    dispatch(actions.setCurrentRegStep(step - 1));
  };

  if (process.env.NODE_ENV !== 'development') {
    return null;
  }

  return (
    <div className="dev-btns">
      <button onClick={goBack}>back</button>
      <button onClick={goForth}>go</button>
    </div>
  );
};

export default React.memo(RegDevTools);
